import vLoading from './loading.vue'
import Vue from 'vue'
let instance

const LoadingConstructor=Vue.extend(vLoading)

LoadingConstructor.prototype.hide=function(){
  if(instance.$el ){
    this.$el.remove()
  }
  this.visible=false
  this.$destroy()
}

LoadingConstructor.prototype.show=function(message){
  if(!instance){
    instance.msg=message
    return
  }

  instance.msg=message
  document.body.appendChild(instance.$el)
  Vue.nextTick(()=>{
    instance.visible=true
  })
}

export default (function(){
  instance = new LoadingConstructor({
    el: document.createElement('div'),
  })

  return instance
})()